__turbopack_context__.v({
  "backgroundCircle": "C4ixga_backgroundCircle",
  "characterCountCircle": "C4ixga_characterCountCircle",
  "characterCountCircle-enter": "C4ixga_characterCountCircle-enter",
  "characterCountCircle-enter-active": "C4ixga_characterCountCircle-enter-active",
  "characterCountCircle-exit": "C4ixga_characterCountCircle-exit",
  "characterCountCircle-exit-active": "C4ixga_characterCountCircle-exit-active",
  "characterCountContainer": "C4ixga_characterCountContainer",
  "overLimit": "C4ixga_overLimit",
  "progressCircle": "C4ixga_progressCircle",
  "warning": "C4ixga_warning",
});
